// 导入组件
import Vue from 'vue';
import Router from 'vue-router';
// 登录
import Login from '@/views/Login';
import Signup from '@/views/Signup';
import Forget from '@/views/Forget';
// 首页
import index from '@/views/index';
import ApiProtocol from '@/views/protocol/ApiProtocol';
import Account from '@/views/account/Account';

import AppManage from '@/views/manage/AppManage';
import QuotaManage from '@/views/manage/QuotaManage';
import Invoice from '@/views/pay/Invoice';
import CreateOrderQps from '@/views/pay/CreateOrderQps';
import CreateOrder from '@/views/pay/CreateOrder';
import PayOrder from '@/views/pay/PayOrder';
import SuccessPayOrder from '@/views/pay/SuccessPayOrder';
import WebTraffic from '@/views/manage/WebTraffic';
import SysInvoice from '@/views/pay/SysInvoice';

/**
 * 订单管理
 */
// 交易订单
import Order from '@/views/pay/Order';


// 启用路由
Vue.use(Router);

// 导出路由
export default new Router({
  routes: [{
    path: '/',
    name: '',
    component: index,
    hidden: true,
    meta: {
      requireAuth: false
    }
  }, {
    path: '/login',
    name: '登录',
    component: Login,
    hidden: true,
    meta: {
      requireAuth: false
    }
  },
    {
      path: '/protocol/api',
      name: 'api协议',
      component: ApiProtocol,
      hidden: true,
      meta: {
        requireAuth: false
      }
    },

    {
      path: '/pay/createOrder',
      name: '生成订单',
      component: CreateOrder,
      meta: {
        requireAuth: true
      }
    },

    {
      path: '/pay/payOrder',
      name: '支付订单',
      component: PayOrder,
      meta: {
        requireAuth: true
      }
    },
    {
      path: '/pay/successPayOrder',
      name: '支付成功订单',
      component: SuccessPayOrder,
      meta: {
        requireAuth: true
      }
    },
    {
      path: '/pay/createOrderQps',
      name: '生成QPS订单',
      component: CreateOrderQps,
      meta: {
        requireAuth: true
      }
    },
    {
      path: '/pay/sysInvoice',
      name: '生成系统发票订单',
      component: SysInvoice,
      meta: {
        requireAuth: true
      }
    },

    {
      path: '/signup',
      name: '注册',
      component: Signup,
      hidden: true,
      meta: {
        requireAuth: false
      }
    },

    {
      path: '/forget',
      name: '修改密码',
      component: Forget,
      hidden: true,
      meta: {
        requireAuth: false
      }
    },

    {
      path: '/index',
      name: '首页',
      component: index,
      iconCls: 'el-icon-tickets',
      children: [
        {
          path: '/account',
          name: '账号信息',
          component: Account,
          meta: {
            requireAuth: true
          }
        },
        {
          path: '/manage/app',
          name: '应用管理',
          component: AppManage,
          meta: {
            requireAuth: true
          }
        },
        {
          path: '/manage/quota',
          name: '配额管理',
          component: QuotaManage,
          meta: {
            requireAuth: true
          }
        },

        {
          path: '/manage/webTraffic',
          name: '流量详情',
          component: WebTraffic,
          meta: {
            requireAuth: true
          }
        }, {
          path: '/pay/Order',
          name: '交易订单',
          component: Order,
          meta: {
            requireAuth: true
          }
        }, {
          path: '/pay/invoice',
          name: '发票地址',
          component: Invoice,
          meta: {
            requireAuth: true
          }
        }

      ]
    }]
})



// WEBPACK FOOTER //
// ./src/router/index.js